/** @file Bind-pose entry of a bone: its setup world as number[6], refused when singular. */
import type { Id } from '@pose2d/format/types';
import { invertChecked } from './invertChecked';

/** `Array.from(worldOf(bone))`; VALIDATION at `path` when that world cannot be inverted (zero setup scale). */
export function bindMatrix(worldOf: (bone: Id) => Float64Array, bone: Id, path: string): number[] {
  const world = worldOf(bone);
  invertChecked(world, path, `bone ${bone} has zero scale at setup, so a mesh cannot bind to it`);
  return Array.from(world);
}
